import type {IEmployee, IEmployeeBranch} from '../../domain';
import type {ITeam} from '../../domain/channelsuite/user-services/employee-master-data/team';
import {ApiBaseService} from '../api-base-service';

export enum Endpoints {
    BRANCHES = '/branches',
    EMPLOYEES = '/employees',
    TEAMS = '/teams',
}

export class EmployeeMasterDataApiService extends ApiBaseService {
    constructor(context = '/delegate/employee-master-data') {
        super(`${context}/v3`);
    }


    async getBranchByExternalId(branchExternalId: string): Promise<IEmployeeBranch> {
        return this.http
            .get<IEmployeeBranch[]>(Endpoints.BRANCHES, {params: {
                'external-id': branchExternalId, 'page-size': 1}})
            .then((response) => response.data[0]);
    }

    async getEmployeesByExternalIds(employeeExternalIds: string[]): Promise<IEmployee[]> {
        const params = {
            'external-id': employeeExternalIds.join(','),
            'page-size': employeeExternalIds.length,
        };

        return this.http.get<IEmployee[]>(Endpoints.EMPLOYEES, {params}).then((response) => response.data);
    }


    async getTeamByExternalId(teamExternalId: string): Promise<ITeam> {
        return this.http.get<ITeam[]>(Endpoints.TEAMS, {
            params: {
                'external-id': teamExternalId,
                'page-size': 1
            }
        }).then((response) => response.data[0])
    }
}